"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SignupSuggestionStore {
	dismissedFestivals: string[];
	dismissSuggestion: (festivalSlug: string) => void;
	shouldShowSuggestion: (festivalSlug: string) => boolean;
}

export const useSignupSuggestionStore = create<SignupSuggestionStore>()(
	persist(
		(set, get) => ({
			dismissedFestivals: [],

			dismissSuggestion: (festivalSlug: string) => {
				const current = get().dismissedFestivals;
				if (!current.includes(festivalSlug)) {
					set({ dismissedFestivals: [...current, festivalSlug] });
				}
			},

			shouldShowSuggestion: (festivalSlug: string) => {
				return !get().dismissedFestivals.includes(festivalSlug);
			},
		}),
		{
			name: "signup-suggestion-export",
			partialize: (state) => ({
				dismissedFestivals: state.dismissedFestivals,
			}),
		},
	),
);
